<template>
    <cod-dialog
        :show.sync="showDialog"
        max-width="350px"
    >
        <div slot="content" class="payments-content">
            <template v-if="locale === 'sr'">
                <v-btn
                    class="h60 mt-3"
                    color="success"
                    block
                    large
                    :disabled="paymentTypeDisabled('check')"
                    @click="payAction('check')"
                >
                    {{ $t('general.check') }}
                </v-btn>

                <v-btn
                    class="h60 mt-3"
                    color="info"
                    block
                    large
                    :disabled="paymentTypeDisabled('voucher')"
                    @click="payAction('voucher')"
                >
                    {{ $t('general.voucher') }}
                </v-btn>

                <v-btn
                    class="h60 mt-3"
                    color="warning"
                    block
                    large
                    :disabled="paymentTypeDisabled('mobile_money')"
                    @click="payAction('mobile_money')"
                >
                    {{ $t('general.mobile_money') }}
                </v-btn>
            </template>

            <template v-if="locale === 'me'">
                <v-btn
                    class="h60 mt-3"
                    color="success"
                    block
                    large
                    :disabled="paymentTypeDisabled('order')"
                    @click="payAction('order')"
                >
                    {{ $t('general.issue_order') }}
                </v-btn>

                <v-btn
                    v-if="isAllegra"
                    class="h60 mt-3"
                    color="info"
                    block
                    large
                    :disabled="paymentTypeDisabled('cash') || paymentTypeDisabled('other_noncash')"
                    @click="payAction('installments')"
                >
                    {{ $t('general.installments') }}
                </v-btn>
            </template>

            <v-btn
                class="h60 mt-3"
                color="secondary"
                block
                large
                :disabled="paymentTypeDisabled('other_noncash')"
                @click="payAction('other_noncash')"
            >
                {{ $t('general.other_noncash') }}
            </v-btn>

            <v-btn
                v-if="locale === 'sr'"
                class="h60 mt-3"
                color="error"
                block
                large
                @click="payAction('no_compensation')"
            >
                {{ $t('receipt.no_compensation') }}
            </v-btn>

            <v-btn
                v-if="locale !== 'me'"
                class="h60 mt-3"
                color="default"
                block
                large
                @click="payAction('mixed')"
            >
                {{ $t('general.mixed') }}
            </v-btn>
        </div>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';
import CashRegister from '@/models/CashRegister';
import { mapGetters } from 'vuex';

export default {
    components: {
        CodDialog
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    data: () => ({
        showDialog: false,
    }),

    watch: {
        show(val) {
            this.showDialog = val;
        },
        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    computed: {
        ...mapGetters(['curOrder']),

        curCashRegister() {
            return CashRegister.current()
        },

        noncashOnly() {
            return this.tenant && this.tenant.venue && !!this.tenant.venue.settings.noncash_only;
        }
    },

    methods: {
        payAction(paymentType) {
            this.showDialog = false;

            if(paymentType === 'installments') {
                this.$emit('toggle-dialog', { dialog: 'installments' })
                return
            }

            if(paymentType === 'other_noncash') {
                this.$emit('toggle-dialog', { dialog: 'otherNoncash' })
                return
            }

            if(paymentType === 'mixed') {
                this.$emit('toggle-dialog', { dialog: 'mixedPayment' })
                return
            }

            if(paymentType === 'no_compensation') {
                this.$emit('pay', { paymentType: 'other_noncash', flag: 'type,noCompensation' })
                return
            }

            this.$emit('pay', { paymentType })
        },

        paymentTypeDisabled(type) {
            if(!this.curCashRegister) return true;

            if(this.noncashOnly && ['cash', 'credit_card'].includes(type)) return true;

            if(type === 'advance' && this.curOrder?.refersToAdvance()) return true;

            if(type === 'order') return !this.curOrder || this.curOrder.refersToAdvance();

            if(this.curOrder?.refersToAdvance() && this.curOrder.referredAdvanceOrders()[0].isEinvoice()) return true;

            return !this.curCashRegister.allowsPayment(type);
        },
    }
};
</script>

<style lang="scss" scoped>
.payments-content {
    padding: 0 12px 12px 12px;
}
</style>
